import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import NavMenuItem from '@/layout/components/NavMenu/Item.vue';
import { constantRoutes } from '@/router/index.js';
export default {
  name: 'NavMenu',
  components: {
    NavMenuItem
  },
  data() {
    return {
      routes: []
    };
  },
  computed: {
    firstLevelCompositionModuleId() {
      return this.$store.getters.firstLevelCompositionModuleId;
    },
    activeMenu() {
      const route = this.$route;
      const {
        meta,
        path
      } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    }
  },
  watch: {
    firstLevelCompositionModuleId: {
      handler() {
        this.routes = constantRoutes.filter(item => {
          if (item.path !== '/composition') return true;
          return Boolean(this.firstLevelCompositionModuleId);
        });
      },
      immediate: true
    }
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item;
          return true;
        }
      });

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = {
          ...parent,
          path: '',
          noShowingChildren: true
        };
        return true;
      }
      return false;
    },
    menuPermission(item) {
      let superAdmin = sessionStorage.getItem('superAdmin');
      if (item.admin) {
        return superAdmin === '2';
      } else {
        return !item.hidden;
      }
    },
    // 选择目录
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    }
  }
};